"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const enums_1 = require("../../../../common/enums");
const store_1 = require("../../../../context/store");
const calendarDays_1 = require("../../../../utils/calendarDays");
const common_1 = require("../../../../utils/common");
const react_1 = require("react");
const DayOfWeekText_1 = __importDefault(require("../../../dayOfWeekText/DayOfWeekText"));
/**
 * Render text representation of days
 *
 * @param props
 * @constructor
 */
const CalendarHeaderWeekDays = (props) => {
    const { daysNum, days } = props;
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { width, selectedView, isMobile, config, translations } = store;
    const { weekDayStart } = config;
    const isMonthView = selectedView === enums_1.CALENDAR_VIEW.MONTH;
    const colWidth = isMonthView
        ? width / daysNum
        : (0, common_1.getCorrectWidth)(width, isMobile, selectedView) / daysNum;
    const weekDays = weekDayStart === enums_1.WEEKDAY_START.SUNDAY ? calendarDays_1.daysTextSundayStart : calendarDays_1.daysText;
    const renderDaysText = () => {
        const dayTextColumnWidth = {
            width: colWidth,
        };
        if (isMonthView) {
            return weekDays.map((day) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__CalendarHeaderWeekDays__col', style: dayTextColumnWidth }, { children: (0, jsx_runtime_1.jsx)("p", Object.assign({ className: (0, common_1.parseCssDark)('Kalend__text Kalend__CalendarHeaderWeekDays__text', store.isDark) }, { children: translations['weekDays'][`${day}`] })) }), day)));
        }
        return days.map((calendarDay) => ((0, jsx_runtime_1.jsx)(DayOfWeekText_1.default, { day: calendarDay, width: colWidth }, calendarDay.toString())));
    };
    const namesForDays = renderDaysText();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__CalendarHeaderWeekDays__wrapper' }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__CalendarHeaderWeekDays__container' }, { children: namesForDays })) })));
};
exports.default = CalendarHeaderWeekDays;
